import { render, staticRenderFns } from "./AddItemFiles.vue?vue&type=template&id=047177b8&"
import script from "./AddItemFiles.vue?vue&type=script&lang=js&"
export * from "./AddItemFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports